export default __webpack_public_path__ + "static/media/History Dot, Orange.3913e9f6.png";